import { lazyLoad } from '../../../shared/utils/loadable';

export const PlansPage = lazyLoad(
  () => import('./index'),
  (module) => module.Plans,
);
